var isMac = /macintosh|mac os x/i.test(navigator.userAgent)
let flag = false
if (isMac) {
  flag = true
}

export default flag



// WEBPACK FOOTER //
// ./src/assets/js/systemIdenty.js